import axios from 'axios';
import ENV from '../constants/Environment.js';

export default new class MessagesService {

    async sendPrayerRequest(pMessage) {
        const options = {
			method: 'POST',
			headers: { 'content-type': 'application/json' },
			data: {
				"firstName": pMessage.FirstName,
				"lastName": pMessage.LastName,
				"email": pMessage.Email,
				"phone": pMessage.Phone,
				"request": pMessage.Request,
				"active": 1
			},
			url: `${ENV.HEROKU_API_ENDPOINT}/prayer/`,
		};

		try {
			const response = await axios(options);
			return {
				statusCode: response.status,
				results: response.data.results
			}
		} catch (error) {
			return {
				statusCode: error.response.status,
				results: error.response.data
			}
		}
    }

}
